const getFullMonthName = (index) => {
  const months = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
  
  return months[index]
}

module.exports = {
  getFullMonthName
}